const settings = {
	dev: {
		apiUrl: 'https://api-hct.fast-it.org/api/v1',
		apiDataUrl: 'https://api-hct.fast-it.org/',
		url: 'https://hct.fast-it.org/',
		//apiUrl: 'http://127.0.0.1:3000/api/v1',
		//url: 'http://127.0.0.1:3000/',
		storeId: 1,
	},
};

const getCurrentSettings = () => {
	return settings.dev;
};

export default getCurrentSettings();
